module.exports = "/_next/static/videos/golf-5-9be6acb69fc77e5be78e098d6a4cb2ec.webm";